// src/api/departmentApi.js
import api from '../axiosConfig';

const API_URL = '/api/departments'; 

export const fetchDepartments = () => api.get(API_URL);
export const createDepartment = (data) => api.post(API_URL, data);
export const updateDepartment = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteDepartment = (id) => api.delete(`${API_URL}/${id}`);
